"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _js = require("@agile-actors/actions/dist/js");

var emit = function emit() {
  return (0, _operators.map)(_js.emit);
};

var _default = emit;
exports["default"] = _default;